import React, { Component } from 'react';
import Accordion from './Accordion';

class ServiceWrapper extends Component {

    render(){
        return (
            <div>
                <Accordion>
                    <div label="Software Development">
                        <p>
                            We can develop software across various platforms whether that would be mobile, web , desktop or server applications to suit your needs.
                        </p>
                    </div>
                    <div label="Database">
                        <p>
                            Our database experts can provide guidance on everything from database design and implementation to optimization.
                        </p>
                    </div>
                    <div label="Sharepoint">
                        <p>
                            Collaboration and process automation made easy. Let us help with:
                            <ul>
                                <li>Team collaboration</li>
                                <li>Office 365</li>
                                <li>Record management</li>
                                <li>Content management</li>
                            </ul>
                        </p>
                    </div>
                    <div label="UI/UX & Branding">
                        <p>
                            A Brand is an identity, a community, and a statement. It defines a business by what it says and the reputation it has made. We help our customers hone their vision and position it to their target market.                         </p>
                    </div>
                </Accordion>
            </div>
        );
    }
}

export default ServiceWrapper;